import { Id, Store } from '@nextforce/api'
import { t } from 'app/i18l'

export function storeHasManagementRole(store: Store | undefined): boolean {
  if (!store?.roles) {
    return false
  }

  return !!store.roles.find(
    role => role === 'manager' || role === 'observer' || role === 'admin'
  )
}

export function crossStoreShiftAssignError(
  store: Store | undefined,
  activeStoreId: Id | undefined
) {
  const isStoreNearBy = store?.nearByStores?.includes(Number(activeStoreId))
  const isSharingAllowed =
    store?.preferences?.allowCrossStoreSharingForObservers

  return store
    ? isSharingAllowed
      ? isStoreNearBy
        ? false
        : new Error(t('storeTooFarError'))
      : store?.id === activeStoreId
      ? false
      : new Error(t('sharingIsOffError'))
    : false
}
